import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiControllerService } from '../api-controller-service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

export interface SupportData {
  id?: number;
  locationAddress: string;
  emailSupport: string;
  emailSales: string;
  phoneSupport: string;
  website: string;
  createdAt?: string;
  updatedAt?: string;
}

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.css'
})
export class SupportComponent implements OnInit {
  supportData: SupportData | null = null;
  isLoading: boolean = true;
  errorMessage: string = '';
  
  constructor(
    private apiService: ApiControllerService,
  ) {}

  async ngOnInit() {
    this.loadSupportData();
  }

  loadSupportData() {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.apiService.getSupportInfo().subscribe({
      next: (response: any) => {
        if (response) {
          this.supportData = response;
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Error fetching support data:', error);
        this.errorMessage = 'Failed to load support information. Please try again.';
        this.isLoading = false;
      }
    });
  }
}
